import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory as createHistory } from 'history';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { reducers, rootSaga } from './index';

export const history = createHistory();

const sagaMiddleware = createSagaMiddleware();

const getMiddleware = () => {
  if (process.env.NODE_ENV === 'development') {
    const composeEnhancers = composeWithDevTools({
      trace: true,
      traceLimit: 25,
    });
    return composeEnhancers(
      applyMiddleware(sagaMiddleware, routerMiddleware(history), createLogger())
    );
  }
  // Enable additional logging in non-production environments.
  return applyMiddleware(sagaMiddleware, routerMiddleware(history));
};

const storeCreator = state => {
  const newStore = createStore(reducers(history), state, getMiddleware());
  sagaMiddleware.run(rootSaga);
  return newStore;
};

const store = storeCreator();
export default store;
